import { useReduxState } from 'hooks';
import { ModalButton, User } from 'components/common';
import { AchievementUserCompletionData } from '.';

import type { AchievementData, UserWithBasicData } from 'shared-types';

interface Props {
  achievementData: AchievementData;
  user: UserWithBasicData;
}

const AchievementUsersDetails = ({ achievementData, user }: Props) => {
  const { messages } = useReduxState();

  return (
    <ModalButton
      category="lighter"
      isRounded={true}
      modalProps={{
        closeButton: true,
        title: messages.achievementCompletionDetails,
        width: 'medium'
      }}
      size="small"
      style={{
        padding: '4px 9px 5px'
      }}
      text={messages.commonViewAction}
    >
      <div className="data">
        <AchievementUserCompletionData
          achievementData={achievementData}
          user={user}
        />

        <style jsx>{`
          .data {
            padding: 10px 0;
          }
        `}</style>
      </div>
    </ModalButton>
  );
};

export default AchievementUsersDetails;
